import { Stack, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { Item } from 'typings'
import { Tag, TagsListTruncate } from 'ui'
import { GenericShipping, ShippingApplyTo } from '../../typings'
import messages from './messages'
import styles from './styles'

const ContentCheapest = () => (
  <Text variant="detail" tone="secondary" className={styles.view.cheapest}>
    <FormattedMessage {...messages.view.cheapest} />
  </Text>
)

const ContentSelected = (props: { values: Item[] }) => {
  const { values } = props

  return (
    <Stack space="$space-2" className={styles.view.selected}>
      <Text variant="detail" tone="secondary">
        <FormattedMessage {...messages.view.selected} />
      </Text>

      <TagsListTruncate content={values.map(({ name }) => name)}>
        {values.map(({ name }, index) => (
          <TagsListTruncate.Atom key={index}>
            <Tag>{name}</Tag>
          </TagsListTruncate.Atom>
        ))}
      </TagsListTruncate>
    </Stack>
  )
}

type ContentProps = {
  config: GenericShipping<any>
}

export function ShippingVariantView(props: ContentProps) {
  const { config } = props

  switch (config.applyTo) {
    case ShippingApplyTo.all:
      return null
    case ShippingApplyTo.cheapest:
      return <ContentCheapest />
    case ShippingApplyTo.selected:
      return <ContentSelected values={config.selectedMethods} />
  }
}
